import { decodeJwt } from "jose";
import { END_POINT } from "../utils/End-points";
import axios from "axios";

let accessToken = null;
let isRefreshing = false; // Flag to indicate if refresh is in progress
let refreshSubscribers = []; // Queue to hold requests waiting for the token

export const setAccessToken = (token) => {
  accessToken = token;
};

export const getAccessToken = () => accessToken;

export const decodeToken = (token) => {
  try {
    return token ? decodeJwt(token) : null;
  } catch (error) {
    return null;
  }
};

export const clearAccessToken = () => {
  accessToken = null;
};

// Add a subscriber to the queue to wait for token refresh
const addSubscriber = (callback) => {
  refreshSubscribers.push(callback);
};

// Notify all waiting requests to retry
const onTokenRefreshed = (newAccessToken) => {
  refreshSubscribers.forEach((callback) => callback(newAccessToken));
  refreshSubscribers = []; // Clear the queue after notifying
};

// Refresh token function
export const refreshToken = async () => {
  try {  
    const response = await axios.post(
      `${END_POINT.AUTH_BASE_URL + END_POINT.AUTH.REFRESH_TOKEN}`,
      {},
      {
        withCredentials: true,
      }
    );

    const newAccessToken = response?.data?.accessToken;
    setAccessToken(newAccessToken);
    onTokenRefreshed(newAccessToken);
    return newAccessToken;
  } catch (err) {
    clearAccessToken();
    return null;
  }
};

// Method to get the token and wait for refresh if needed
export const getToken = async () => {
  if (accessToken) {
    const decoded = decodeToken(accessToken);

    const expTime = decoded?.exp;
  
    if (expTime) {
  
      const currentTime = Math.floor(Date.now() / 1000); // current time in seconds
  
      if (expTime > currentTime) {
        return Promise.resolve(accessToken); // valid token
      }
    }
  }

  if (isRefreshing) {
    return new Promise((resolve) => {
      addSubscriber(resolve);
    });
  }

  isRefreshing = true;
  const newAccessToken = await refreshToken();
    isRefreshing = false;
    return newAccessToken;
};
